module.exports = {
    RECEIVE_ALL_FRACTIONS: 'RECEIVE_ALL_FRACTIONS',
    RECEIVE_FRACTION: 'RECEIVE_FRACTION',
    RESET_FRACTION: 'RESET_FRACTION',
}